import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiStoryPriority, CasiStoryStatus, CasiStoryType, IProjectFromWeb } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiUserStoryPriorityService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<CasiStoryPriority[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/userstorypriority`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => CasiStoryPriority.create(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserStoryPriorityService extends CasiUserStoryPriorityService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('userstorypriority', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`userstorypriority/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('userstorypriority', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`userstorypriority/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`userstorypriority/${id}`, 'destroy');
  }

}
